import {Button, ButtonGroup, Chips, closeCurrentDialog, DataStatus} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useState} from 'react';

import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {useCodeList} from '@dms/shared';

interface BusinessCaseSourceDialogProps {
  onConfirm: (sourceCodeId: string) => Promise<void>;
}

export function BusinessCaseSourceDialog(props: BusinessCaseSourceDialogProps) {
  const [sourceCodeId, setSourceCodeId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [businessCaseSourcesCodelist, {isLoading: isCodeListLoading, isError: isCodeListError}] =
    useCodeList('interest_source');

  const sourceOptions =
    businessCaseSourcesCodelist?.map((item) => ({
      label: item.name,
      value: item.codeId,
    })) ?? [];

  const handleConfirm = () => {
    if (sourceCodeId) {
      setIsLoading(true);
      props.onConfirm(sourceCodeId).catch(() => setIsLoading(false));
    }
  };

  return (
    <DataStatus isLoading={isCodeListLoading} isError={isCodeListError}>
      <VStack spacing={4}>
        <Chips
          value={sourceCodeId ? [sourceCodeId] : []}
          onChange={(values) => setSourceCodeId(values?.[0] ?? null)}
          options={sourceOptions}
          isMultiple={false}
          data-testid={testIds.customer.detail('businessCaseSourceChips')}
        />
        <ButtonGroup align="right">
          <Button
            variant="secondary"
            title={i18n.t('general.actions.cancel')}
            onClick={closeCurrentDialog}
          />
          <Button
            variant="primary"
            title={i18n.t('page.businessCase.actions.create')}
            onClick={handleConfirm}
            isDisabled={isNilOrEmpty(sourceCodeId)}
            isLoading={isLoading}
            data-testid={testIds.customer.detail('businessCaseSourceConfirm')}
          />
        </ButtonGroup>
      </VStack>
    </DataStatus>
  );
}
